import Vuex from 'vuex';
import Vue from "vue";
import timeparkApi from "@/timeparkApi";

const AdminUser = "Admin";
const RegularUser = "Regular";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    products: [],
    machines: [],
    users: [],
    exporterMetadataDefinitions: [],
    userMetadataDefinitions: [],
    timeRecordingMetadataDefinitions: [],
    timeModels: [],
    currentUserRole: RegularUser,
    hasTenantMachineUsageReportGenerator: false,
    extraCharges: [],
  },
  mutations: {
    setMachines(state, machines) {
      state.machines = machines;
    },
    setProducts(state, products) {
      state.products = products;
    },
    updateSystemSettings(state, systemSettings) {
      state.users = systemSettings.users;
      state.currentUserRole = systemSettings.currentUserRole;
      state.hasTenantMachineUsageReportGenerator = systemSettings.hasTenantMachineUsageReportGenerator;
    },
    setTimeModels(state, t) {
      state.timeModels = t ? t : [];
    },
    setExporterMetadataDefinitions(state, m) {
      state.exporterMetadataDefinitions = m;
    },
    setUserMetadataDefinitions(state, m) {
      state.userMetadataDefinitions = m;
    },
    setTimeRecordingMetadataDefinitions(state, m) {
      state.timeRecordingMetadataDefinitions = m;
    },
    setExtraCharges(state, extraCharges) {
      state.extraCharges = extraCharges;
    },
  },
  getters: {
    currentUserIsAdministrator: state => state.currentUserRole === AdminUser,
  },
  actions: {
    async loadMachines({ commit }) {
      const {data: machines} = await timeparkApi.machinesApi.getMachines();
      commit('setMachines', machines);
    },
    async loadProducts({ commit }) {
      const { data: products } = await timeparkApi.productsApi.getAll();
      commit('setProducts', products)
    },
  }
});

export default store;
